module.exports = __webpack_public_path__ + "static/media/12.0cf91ae0.jpeg";